module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "userList"
  }, [_c('el-table', {
    ref: "userList",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "row-class-name": _vm.setRowname,
      "border": "",
      "height": _vm.userTableHeight
    },
    on: {
      "expand-change": _vm.changeExpand
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.LOGIN) ? _c('user-list', {
          attrs: {
            "id": props.row.LOGIN
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.tableHead), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "label": item.labelName,
        "prop": item.propName,
        "min-width": item.width,
        "show-overflow-tooltip": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(item.propName == 'LOGIN') ? _c('span', [(_vm.showHistory) ? _c('span', [_c('span', {
            staticClass: "loginClass",
            on: {
              "click": function($event) {
                return _vm.getLoginInfo(scope.row.LOGIN)
              }
            }
          }, [_vm._v(_vm._s(scope.row[item.propName]))])]) : _c('span', [_vm._v(_vm._s(scope.row[item.propName]))])]) : (item.propName == 'NAME') ? _c('span', [_c('span', {
            staticClass: "loginClass",
            on: {
              "click": function($event) {
                return _vm.getUserInfo(scope.row)
              }
            }
          }, [_vm._v(_vm._s(scope.row[item.propName]))])]) : _c('span', [_vm._v(_vm._s(scope.row[item.propName]))])]
        }
      }], null, true)
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('table.operate'),
      "min-width": 150
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.showEditBtn) ? _c('span', {
          staticClass: "edit-icon",
          on: {
            "click": function($event) {
              return _vm.editUser(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "edit-icon",
          staticStyle: {
            "margin": "0 5px"
          },
          on: {
            "click": function($event) {
              return _vm.editAuth(scope.row)
            }
          }
        }, [(scope.row.ENABLE == '0') ? _c('span', [_c('i', {
          staticClass: "fa fa-lock",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.ENABLE == '1') ? _c('span', [_c('i', {
          staticClass: "fa fa-unlock-alt",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e()]), _vm._v(" "), _c('span', {
          staticClass: "send-icon",
          class: {
            iconColor: scope.row.IS_SENT_EMAIL == '0' ? true : false, iconColored: scope.row.IS_SENT_EMAIL == '0' ? false : true
          },
          staticStyle: {
            "margin": "0 5px"
          },
          on: {
            "click": function($event) {
              return _vm.sendEmail(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-paper-plane",
          attrs: {
            "aria-hidden": "true"
          }
        })]), _vm._v(" "), _c('span', {
          staticClass: "send-icon",
          staticStyle: {
            "margin": "0 5px"
          },
          on: {
            "click": function($event) {
              return _vm.addLowerUser(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-user-plus",
          attrs: {
            "aria-hidden": "true"
          }
        })])]
      }
    }])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 15, 20, 30, 50, 100, 200],
      "page-size": _vm.tablePageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "historyDialog",
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible,
      "width": "90%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialogTitle",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [(_vm.showtradeReport) ? _c('el-button', {
    class: {
      btnActive: _vm.isActive
    },
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.toPosition
    }
  }, [_vm._v(_vm._s(_vm.$t('button.positionReport')))]) : _vm._e(), _vm._v(" "), (_vm.showtradeHistory) ? _c('el-button', {
    class: {
      btnActive: !_vm.isActive
    },
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.toHistory
    }
  }, [_vm._v(_vm._s(_vm.$t('button.tradingHistory')))]) : _vm._e(), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": _vm.$t('button.to'),
      "start-placeholder": _vm.$t('button.startDate'),
      "end-placeholder": _vm.$t('button.endDate'),
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.changeDate
    },
    model: {
      value: (_vm.dateValue),
      callback: function($$v) {
        _vm.dateValue = $$v
      },
      expression: "dateValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tradeLoading),
      expression: "tradeLoading"
    }],
    staticClass: "dialogContent"
  }, [_c('el-table', {
    ref: "tradeTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tradeTable,
      "stripe": "",
      "border": "",
      "height": "450"
    }
  }, _vm._l((_vm.tradeTableHead), function(item, index) {
    return (item.status) ? _c('el-table-column', {
      key: index,
      attrs: {
        "label": item.labelName,
        "prop": item.propName,
        "min-width": item.width
      }
    }) : _vm._e()
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.tradeCurrentPage,
      "page-sizes": [10, 15, 20, 30, 50, 100, 200],
      "page-size": _vm.tradePageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.tradeTotal
    },
    on: {
      "size-change": _vm.tradeSizeChange,
      "current-change": _vm.tradeCurrentChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "userDialog",
    attrs: {
      "title": _vm.$t('dialog.userInfo'),
      "visible": _vm.userVisible,
      "width": "50%",
      "before-close": _vm.closeUserinfo
    },
    on: {
      "update:visible": function($event) {
        _vm.userVisible = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userInfoLoading),
      expression: "userInfoLoading"
    }]
  }, _vm._l((_vm.userInfoArr), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "userInfo"
    }, [_c('div', {
      staticClass: "userLabel"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "userValue"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "editDialog"
  }, [_c('el-dialog', {
    ref: "editDialog",
    attrs: {
      "title": _vm.$t('dialog.editUser'),
      "visible": _vm.editVisible,
      "width": "70%",
      "before-close": _vm.editClose
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [_c('el-row', {
    staticClass: "edit-form",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "200px",
      "rules": _vm.editRules
    }
  }, [_c('el-col', {
    staticClass: "editLeftform",
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('dialog.username'),
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.enterUsername'),
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.username),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "username", $$v)
      },
      expression: "editForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('dialog.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.enterPass')
    },
    model: {
      value: (_vm.editForm.password),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "password", $$v)
      },
      expression: "editForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('dialog.confirmPass'),
      "prop": "verifyPass"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.enterPassAgain')
    },
    model: {
      value: (_vm.editForm.verifyPass),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "verifyPass", $$v)
      },
      expression: "editForm.verifyPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.enterEmail')
    },
    model: {
      value: (_vm.editForm.email),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "email", $$v)
      },
      expression: "editForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('dialog.userGroup'),
      "prop": "userGroup"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('placeholder.selectGroup')
    },
    on: {
      "change": _vm.changeGroup
    },
    model: {
      value: (_vm.editForm.userGroup),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "userGroup", $$v)
      },
      expression: "editForm.userGroup"
    }
  }, _vm._l((_vm.groupOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('dialog.Superior'),
      "prop": "superior"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.selectSuperior')
    },
    model: {
      value: (_vm.editForm.superior),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "superior", $$v)
      },
      expression: "editForm.superior"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "user_comment",
    attrs: {
      "label": _vm.$t('home.comment'),
      "prop": "comment"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": _vm.$t('home.enterComment')
    },
    model: {
      value: (_vm.editForm.comment),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "comment", $$v)
      },
      expression: "editForm.comment"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "editRightform",
    attrs: {
      "span": 13
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('table.enName'),
      "prop": "enName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.enterName')
    },
    model: {
      value: (_vm.editForm.enName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "enName", $$v)
      },
      expression: "editForm.enName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('table.cnName'),
      "prop": "cnName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.enterName')
    },
    model: {
      value: (_vm.editForm.cnName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "cnName", $$v)
      },
      expression: "editForm.cnName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('dialog.mobile'),
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.enterPhone')
    },
    model: {
      value: (_vm.editForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "phone", $$v)
      },
      expression: "editForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('dialog.checkGroup'),
      "prop": "groupRadio"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "border": ""
    },
    model: {
      value: (_vm.editForm.groupRadio),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "groupRadio", $$v)
      },
      expression: "editForm.groupRadio"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.yes')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0",
      "border": ""
    },
    model: {
      value: (_vm.editForm.groupRadio),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "groupRadio", $$v)
      },
      expression: "editForm.groupRadio"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.no')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('dialog.checkMobile'),
      "prop": "contactRadio"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "border": ""
    },
    model: {
      value: (_vm.editForm.contactRadio),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "contactRadio", $$v)
      },
      expression: "editForm.contactRadio"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.yes')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0",
      "border": ""
    },
    model: {
      value: (_vm.editForm.contactRadio),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "contactRadio", $$v)
      },
      expression: "editForm.contactRadio"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.no')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('dialog.lock'),
      "prop": "loginRadio"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "border": ""
    },
    model: {
      value: (_vm.editForm.loginRadio),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "loginRadio", $$v)
      },
      expression: "editForm.loginRadio"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.yes')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0",
      "border": ""
    },
    model: {
      value: (_vm.editForm.loginRadio),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "loginRadio", $$v)
      },
      expression: "editForm.loginRadio"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.no')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.editClose
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancle')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editUserSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('button.confirm')))])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('dialog.addLowerUser'),
      "visible": _vm.lowerVisible,
      "width": "80%",
      "before-close": _vm.lowerClose
    },
    on: {
      "update:visible": function($event) {
        _vm.lowerVisible = $event
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "max-height": "calc(100vh - 400px)",
      "overflow": "auto"
    },
    attrs: {
      "gutter": 15
    }
  }, _vm._l((_vm.lowerTotal), function(val, index) {
    return _c('el-col', {
      key: index,
      staticClass: "marginBtm",
      attrs: {
        "span": 4
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": _vm.$t('placeholder.enterLowerUser')
      },
      on: {
        "input": function($event) {
          return _vm.checkInput(val.value, index)
        }
      },
      model: {
        value: (val.value),
        callback: function($$v) {
          _vm.$set(val, "value", $$v)
        },
        expression: "val.value"
      }
    })], 1)
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.lowerClose
    }
  }, [_vm._v(_vm._s(this.$t('button.cancle')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.lowerSubmit
    }
  }, [_vm._v(_vm._s(this.$t('button.confirm')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41973afc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/userList.vue
// module id = 1159
// module chunks = 1